import {BaseReference} from './BaseReference';
import {Bathroom} from '../hotel/model/accessibility/Bathroom';
import {Bedroom} from '../hotel/model/accessibility/Bedroom';
import {General} from '../hotel/model/accessibility/General';
import {AnswerReference, IAnswer} from './Answer';
import {QuestionReference} from './Question';


export class AnswersReference extends BaseReference<{ [key: string]: IAnswer; }> {

  questions: QuestionReference[];


  listMissingQuestions() {

    const questionsByKey  = {};
    this.questions.forEach( ( e ) => { questionsByKey[e.value.key]  = e; });

    Object.keys( this.value ).forEach( ( e ) => { delete questionsByKey[e]; } );

    console.log( [this], 'listMissingQuestions', questionsByKey );

  }

  getPhotosAnswers(): AnswerReference[] {

    const answer = [];

    for ( const question of this.questions ) {


      if( question.isPhoto ) {

        const anAnswer: IAnswer = this.value[ question.value.key ];
        if( !anAnswer ) {

          // console.warn( [this], 'getPhotosAnswers', '!anAnswer', 'question.value.key', question.value.key);
        } else {

          const reference = new AnswerReference(  question, anAnswer );
          answer.push( reference );
        }
      }
    }

    return answer;
  }

  onSetValue(value: { [key: string]: IAnswer; }|null) {
  }

  constructor( public section: 'bathroom'|'bedroom'|'general',
               value: { [key: string]: IAnswer; }|null,
               public hotelKey: string|null = null,
               ) {

    super( value );

    if ( 'bathroom' === section ) {

      this.questions = QuestionReference.buildArray( Bathroom.getAllQuestionValues() );
    } else if ( 'bedroom' === section ) {

      this.questions = QuestionReference.buildArray( Bedroom.getAllQuestionValues() );
    } else if ( 'general' === section ) {

      this.questions = QuestionReference.buildArray( General.getAllQuestionValues() );
    }

  }

}
